<template>
  <div class="lock" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    <ul>
      <li v-for="(item,i) in lock"  @click="toPush(item.id,'clustDetail')">
        <img class="fmt" :src="baseUrl+item.img" />
        <div class="right">
        <h2>{{item.title}}</h2>
        <div class="price">
          <i><b>¥</b> {{item.rate.split(".")[0]}}.<b>{{item.rate.split(".")[1]}}</b></i>
          <span>{{item.price}}</span>
        </div>
        </div>
        <a>立即预约</a>
      </li>
    </ul>
    <div class="zwsj" v-if="lock.length <= 0">
      <img src="~assets/images/no.png">
    </div>
    <div style="height:40px;"></div>
    <div class="orderfoot" v-if="total > 0" @click="$router.push('clustOrder')">查看我的订单</div>
  </div>
  
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        lock:[],
        userData:[],
        total:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      var id = this.$route.query.id;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/clust?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }

    },
    mounted() {
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.locks();
      }
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      locks:function(){
        var that = this; 
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/lock/clust',
          params:{
            id:id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.lock = res.rs;
          that.total = res.total;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.locks()
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .lock{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }

  .lock ul{
    width:94%;
    display: block;
    margin: 0 auto;
  }

  .lock ul li{
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius:8px;
    width:100%;
    padding:13px 0;
    position:relative;
    margin-bottom:15px;
  }
  .lock ul li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .lock ul li .fmt{
    float:left;
    width:30%;
    border-radius:6px;
    margin-left:3%
  }
  .lock ul li .right{
    float:left;
    width:65%;
    margin-left:2%;
  }
  .lock ul li h2{
    font-size:15px;
    padding:8px
  }
  .lock ul li .price{
    padding-bottom:20px;
    padding-top:15px
  }
  .lock ul li .price span{
    text-decoration: line-through;
    color:#999;
    font-size:14px;
    padding-left:10px;
  }


  .lock ul li .price{
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
  }
  .lock ul li .price i{
    color: #FF6600;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .lock ul li .price b{
    font-size:12px;
  }
  .lock ul li a{
    position:absolute;
    right:15px;
    top:65%;
    transform: translateY(-50%);
    color:#2F78FF;
    border: 1px solid #2F78FF;
    border-radius: 30px;
    width: 83px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }

  .lock .orderfoot{
    position: fixed;
    width:84%;
    height:45px;
    line-height:45px;
    text-align:center;
    color:#fff;
    font-size:15px;
    background: #FF751A;
    bottom:10px;
    left:8%;
    border-radius: 45px;
  }
  .lock .zwsj{
    padding-top:80px;
  }
  .lock .zwsj img{
    display:block;
    width:100%;
  }
</style>